import { render, staticRenderFns } from "./CCalendar.vue?vue&type=template&id=2a5ddbaa&"
import script from "./CCalendar.vue?vue&type=script&lang=ts&"
export * from "./CCalendar.vue?vue&type=script&lang=ts&"
import style0 from "./CCalendar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports